export default __webpack_public_path__ + "static/media/7.1cccc6c0.svg";